import { create } from 'event-emitter';
import { calculateTags } from '../links/discovery/calculateTags';
import { parseTypeName } from '../resources/resource';
import { timing } from '../metrics/timing';
const tagChannel = (linkKey, tag) => `${linkKey}::${tag}`;
export const createTagBus = ({
  nodeStore,
  resourceRegistry,
  devtools,
  onMatch,
  onUnmatch
}) => {
  const tagBus = create();
  const tagTeardown = create();
  const announce = (channel, event, handler) => {
    tagBus.emit(channel, event);
    const busOff = tagBus.on(channel, handler);
    return changeContext => {
      busOff();
      tagBus.emit(channel, Object.assign({}, event, {
        type: 'depart',
        changeContext
      }));
    };
  };
  const syncTags = (instanceKey, changeContext) => {
    var _dataResult$tags;
    const startTime = performance.now();
    const node = nodeStore.get(instanceKey);
    if (!node) {
      return;
    }
    tagTeardown.emit(instanceKey, changeContext);
    const typeName = parseTypeName(instanceKey);
    const hasData = node.state.data != null;
    const dataResult = hasData ? calculateTags({
      typeName,
      params: node.meta.params,
      data: node.state.data,
      resourceRegistry
    }) : null;
    const paramTags = node.meta.paramLinkTags;
    const dataTags = (_dataResult$tags = dataResult === null || dataResult === void 0 ? void 0 : dataResult.tags) !== null && _dataResult$tags !== void 0 ? _dataResult$tags : null;
    if (!paramTags && !dataTags) {
      timing.timeSyncTags(performance.now() - startTime, hasData);
      return;
    }
    const processTag = (linkKey, tag) => {
      var _dataResult$contexts, _devtools$onTagAdded;
      const channel = tagChannel(linkKey, tag);
      const myContext = dataResult === null || dataResult === void 0 || (_dataResult$contexts = dataResult.contexts) === null || _dataResult$contexts === void 0 ? void 0 : _dataResult$contexts.get(linkKey, tag);
      const leave = announce(channel, {
        type: 'arrive',
        instanceKey,
        context: myContext,
        changeContext
      }, event => {
        if (event.type === 'arrive') {
          onMatch({
            instanceKey,
            neighborKey: event.instanceKey,
            tag,
            changeContext: event.changeContext,
            myContext,
            theirContext: event.context
          });
        } else {
          onUnmatch({
            instanceKey,
            neighborKey: event.instanceKey,
            tag,
            changeContext: event.changeContext
          });
        }
      });
      const teardownOff = tagTeardown.on(instanceKey, removalContext => {
        var _devtools$onTagRemove;
        leave(removalContext);
        devtools === null || devtools === void 0 || (_devtools$onTagRemove = devtools.onTagRemoved) === null || _devtools$onTagRemove === void 0 || _devtools$onTagRemove.call(devtools, instanceKey, linkKey, tag, removalContext);
        teardownOff();
      });
      devtools === null || devtools === void 0 || (_devtools$onTagAdded = devtools.onTagAdded) === null || _devtools$onTagAdded === void 0 || _devtools$onTagAdded.call(devtools, instanceKey, linkKey, tag, changeContext);
    };
    if (paramTags) {
      for (const [linkKey, tag] of paramTags) {
        processTag(linkKey, tag);
      }
    }
    if (dataTags) {
      for (const [linkKey, tag] of dataTags) {
        processTag(linkKey, tag);
      }
    }
    timing.timeSyncTags(performance.now() - startTime, hasData);
  };
  const clean = (instanceKey, changeContext) => {
    tagTeardown.emit(instanceKey, changeContext);
  };
  return {
    syncTags,
    clean
  };
};